import React, { FC, MouseEvent } from 'react'
/** @jsx jsx */
import { jsx, css, SerializedStyles } from '@emotion/core'
import Analytics from '@lib/Analytics'
import { HIQLogo } from '@components/HIQLogo'
import { DesktopOnly, MobileOnly } from '@components/MediaQuery'
import { PublicDesktopMenu, PublicMobileMenu } from '@components/PublicMenu'
import { ApptBanner, InfoBanner } from '@components/InfoBanner'

import { RequestCall } from './RequestCall'
import {
  PublicHeaderWrapper,
  TopHeader,
  TopHeaderContent,
  HIQLogoWrapper,
  LogoText,
  ActionsWrapper,
  HeaderText,
} from './PublicHeader.elements'
import {LearnMoreBanner} from "@components/InfoBanner/LearnMoreBanner";

type Props = {
  phoneMapping: PhoneMapping
  css?: SerializedStyles
  greenBtnText?: string
  onGreenBtnClick?: () => void
  onRequestCall: () => void
  onGetMyQuote?: () => void
  onLogin?: () => void
  navItems?: NavGroupType[]
  hideLogoTagline?: boolean
  showBannerType?: 'INFO' | 'APPT' | 'NONE' | 'LEARN_MORE'
  onScheduleAEP?: () => void
  onLearnMore?: () => void
  headerText?: string
}

export const PublicHeader: FC<Props> = ({ children, ...props }) => {
  const {
    css,
    greenBtnText,
    navItems,
    onGetMyQuote,
    onGreenBtnClick,
    onLogin,
    onRequestCall,
    phoneMapping,
    hideLogoTagline,
    showBannerType,
    onScheduleAEP,
    headerText,
    onLearnMore
  } = props

  const handleLogoClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    Analytics.log('Click Header Logo')

    setTimeout(() => {
      window.location.href = '/'
    }, 500)
  }

  return (
    <PublicHeaderWrapper>
      <TopHeader>
        <TopHeaderContent css={css}>
          <HIQLogoWrapper href="/" onClick={handleLogoClick}>
            <DesktopOnly>
              <HIQLogo
                height={40}
                width={176}
                aria-label="Go to home page"
              />
            </DesktopOnly>

            <MobileOnly>
              <HIQLogo
                height={27}
                width={118}
                aria-label="Go to home page"
              />
            </MobileOnly>
            {!hideLogoTagline && (
              <LogoText>SPECIAL RATE INSURANCE</LogoText>
            )}
          </HIQLogoWrapper>
          { headerText && <HeaderText dangerouslySetInnerHTML={{ __html: headerText }}/>  }

          <ActionsWrapper>
            <RequestCall
              greenBtnText={greenBtnText}
              onGreenBtnCklick={onGreenBtnClick}
              phoneMapping={phoneMapping}
              onRequestCall={onRequestCall}
              headerText={headerText}
            />

            {navItems && onLogin && (
              <PublicMobileMenu
                greenBtnText={greenBtnText}
                navGroups={navItems}
                onLogin={onLogin}
                onGetMyQuote={onGetMyQuote}
              />
            )}
          </ActionsWrapper>
        </TopHeaderContent>
      </TopHeader>

      {navItems && onLogin && (
        <PublicDesktopMenu
          navGroups={navItems}
          onLogin={onLogin}
        />
      )}

      {children}

      {showBannerType === 'INFO' && (
        <InfoBanner initiateOpen />
      )}
      {showBannerType === 'APPT' && onScheduleAEP && (
        <ApptBanner
          initiateOpen
          onSchedule={onScheduleAEP}
          includeTimer={false}
        />
      )}
      {showBannerType === 'LEARN_MORE' && (
        <LearnMoreBanner
          initiateOpen
          onLearnMore={onLearnMore}
        />
      )}
    </PublicHeaderWrapper>
  )
}
